export { default } from "./tabs";
